// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeContainer {
  display: flex;
  flex-direction: column;
  height: 90vh;
  /* border: 1px solid red; */
}
.homeContaint {
  margin: 0px 30px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  /* border: 1px solid green; */
}

.homeContaint h1 {
  margin-top: 20px;
  color: var(--dark-color);
}

/* Breadcrumbs */

.breadcrumb {
  padding: 24px 24px 24px 0px;
  /* margin-bottom: 16px; */
  list-style: none;
  display: flex;
  font-size: 16px;
  font-weight: 500;
  /* border: 1px solid red; */
}

.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 8px;
  padding-left: 8px;
  color: var(--text-color);
  content: "/";
}

.breadcrumb-item + .breadcrumb-item.active::before {
  color: var(--text-color);
}

.breadcrumb-item + .breadcrumb-item a::before {
  content: none;
}

.breadcrumb-item.active {
  color: var(--secondary-color);
}

/* .breadcrumb-item.active:hover {
  color: var(--text-color);
} */

.breadcrumb-item a {
  color: var(--dark-color);
  text-decoration: none;
}

.breadcrumb-item a:hover {
  color: var(--secondary-color);
}


`, "",{"version":3,"sources":["webpack://./src/Component/Home/HomeStyle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,gBAAgB;;AAEhB;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".homeContainer {\n  display: flex;\n  flex-direction: column;\n  height: 90vh;\n  /* border: 1px solid red; */\n}\n.homeContaint {\n  margin: 0px 30px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  /* border: 1px solid green; */\n}\n\n.homeContaint h1 {\n  margin-top: 20px;\n  color: var(--dark-color);\n}\n\n/* Breadcrumbs */\n\n.breadcrumb {\n  padding: 24px 24px 24px 0px;\n  /* margin-bottom: 16px; */\n  list-style: none;\n  display: flex;\n  font-size: 16px;\n  font-weight: 500;\n  /* border: 1px solid red; */\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  display: inline-block;\n  padding-right: 8px;\n  padding-left: 8px;\n  color: var(--text-color);\n  content: \"/\";\n}\n\n.breadcrumb-item + .breadcrumb-item.active::before {\n  color: var(--text-color);\n}\n\n.breadcrumb-item + .breadcrumb-item a::before {\n  content: none;\n}\n\n.breadcrumb-item.active {\n  color: var(--secondary-color);\n}\n\n/* .breadcrumb-item.active:hover {\n  color: var(--text-color);\n} */\n\n.breadcrumb-item a {\n  color: var(--dark-color);\n  text-decoration: none;\n}\n\n.breadcrumb-item a:hover {\n  color: var(--secondary-color);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
